import { render, staticRenderFns } from "./sendPoint.vue?vue&type=template&id=37776180&scoped=true"
import script from "./sendPoint.vue?vue&type=script&lang=js"
export * from "./sendPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37776180",
  null
  
)

export default component.exports